<template>
  <Copy :text="text">
    <span class="ag-ellipsis" :title="text">{{ text }}</span>
  </Copy>
</template>

<script>
import { Copy} from '../../components/thats/Thats'
export default {
  // AG Grid Vue passes `params`
  // props: ['params'],
  components : {
    Copy
  },
  computed: {
    text() {
      return String((this.params && this.params.value) ?? '')
    }
  }
}
</script>
